import { NavLink } from "react-router-dom";
import LogoSVG from "./svg/LogoSVG";
import HomeSVG from "./svg/HomeSVG";
import PencilSVG from "./svg/PencilSVG";
import ReportsSVG from "./svg/ReportsSVG";
import QuestionSVG from "./svg/QuestionSVG";
import SettingsSVG from "./svg/SettingsSVG";
import DeviceSVG from "./svg/DeviceSVG";
import NewsSVG from "./svg/NewsSVG";

const SideBar = ({ active }) => {
  return (
    <nav
      className={
        active
          ? active !== "disabled"
            ? "sidebar sidebar--active"
            : "sidebar sidebar--disabled"
          : "sidebar"
      }
      aria-label="Dashboard Menu"
    >
      <LogoSVG className="sidebar__logo" />
      <div className="sidebar__nav">  
        <ul className="sidebar__items">
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/home"
            >
              <HomeSVG className="sidebar__icon"/>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/reports"
            >
              <ReportsSVG className="sidebar__icon"/>
              Reports
            </NavLink>
          </li>
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/manage"
            >
              <PencilSVG className="sidebar__icon"/>
              Manage
            </NavLink>
          </li>
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/devices"
            >
              <DeviceSVG className="sidebar__icon"/>
              Devices
            </NavLink>
          </li>
        </ul>
        <ul className="sidebar__items">
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/news"
            >
              <NewsSVG className="sidebar__icon"/>
              News
            </NavLink>
          </li>
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/help"
            >
              <QuestionSVG className="sidebar__icon"/>
              Help
            </NavLink>
          </li>
          <li>
            <NavLink
              className="sidebar__link"
              activeClassName="sidebar__link--active"
              to="/settings"
            >
              <SettingsSVG className="sidebar__icon"/>
              Settings
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default SideBar;
